import { render, staticRenderFns } from "./CertificateAuditing.vue?vue&type=template&id=c10e0f2c&scoped=true"
import script from "./CertificateAuditing.vue?vue&type=script&lang=js"
export * from "./CertificateAuditing.vue?vue&type=script&lang=js"
import style0 from "./CertificateAuditing.vue?vue&type=style&index=0&id=c10e0f2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10e0f2c",
  null
  
)

export default component.exports